module.exports = __webpack_public_path__ + "static/media/1-8.26d00c75.svg";